import React, { useEffect, useState } from "react";
import * as navigationSettings_fr from "./fr-FR/navigationSettings";
import * as navigationSettings_fr_BE from "./fr-BE/navigationSettings";
import * as navigationSettings_nl_BE from "./nl-BE/navigationSettings";
import { LANG_FR_BE, LANG_FR_FR, LANG_NL_BE } from "../../constants";
import { Navigation } from "./Navigation";

const LOCALE_NAVIGATION_SETTINGS = {
  [LANG_FR_FR]: navigationSettings_fr,
  [LANG_FR_BE]: navigationSettings_fr_BE,
  [LANG_NL_BE]: navigationSettings_nl_BE,
};

/**
 * The top Header, locale dependant. Defaults to french
 */
export const Header = ({ locale = LANG_FR_FR }) => {
  const SCROLL_THRESH = 10;
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > SCROLL_THRESH);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="h-3"></div>
      <div
        className={`w-full ${
          isScrolled ? " sticky top-0 z-50 shadow-sm bg-white" : ""
        }`}
      >
        <Navigation
          locale={locale}
          rolesMenuItem={LOCALE_NAVIGATION_SETTINGS[locale]?.rolesMenuItem}
          otherMenuItems={LOCALE_NAVIGATION_SETTINGS[locale]?.otherMenuItems}
        />
      </div>
    </>
  );
};
